function setToLocalStorageTicketStatusArray(
  categoryTickets,
  isTicketPass,
  ticketId
) {
  let ticketStatusArray = localStorage.getItem("ticketStatusArray");
  if (ticketStatusArray === null) {
    ticketStatusArray = [
      {
        ticketId: parseInt(ticketId),
        ticketStatus: isTicketPass,
        ticketCategory: categoryTickets
      }
    ];
    localStorage.setItem(
      "ticketStatusArray",
      JSON.stringify(ticketStatusArray)
    );
  } else {
    ticketStatusArray = JSON.parse(ticketStatusArray);

    const [filteredTicketStatusArray] = ticketStatusArray.filter(
      ticketStatusItem =>
        parseInt(ticketId) === ticketStatusItem.ticketId &&
        categoryTickets === ticketStatusItem.ticketCategory
    );
    if (filteredTicketStatusArray !== undefined) {
      const index = ticketStatusArray.indexOf(filteredTicketStatusArray);
      ticketStatusArray[index] = {
        ticketId: parseInt(ticketId),
        ticketStatus: isTicketPass,
        ticketCategory: categoryTickets
      };
      localStorage.setItem(
        "ticketStatusArray",
        JSON.stringify(ticketStatusArray)
      );
    } else {
      ticketStatusArray = [
        ...ticketStatusArray,
        {
          ticketId: parseInt(ticketId),
          ticketStatus: isTicketPass,
          ticketCategory: categoryTickets
        }
      ];
      localStorage.setItem(
        "ticketStatusArray",
        JSON.stringify(ticketStatusArray)
      );
    }
  }
}

export default setToLocalStorageTicketStatusArray;
